import React from "react";
import LoginSidebar from "./LoginSidebar";

const LoginLayout = (props) => {
  return (
    <section className="login-section">
      <div className="lg-left">
        <LoginSidebar />
      </div>
      <div className="lg-right">
        {/* <div className="logo">
                    <img src={logo} alt="logo"/>
                </div>                 */}
        {props.children}
      </div>
    </section>
  );
};
export default LoginLayout;
